import React, { useState } from "react";
import Loader from "../Loader/Loader"; // Assuming you have a loader component
import pdf from "./pdf.png";
import noInvoice from "../../images/Invoice not.jpeg";

const ViewInvoiceDetails = ({ invoiceDetails, close }) => {
  const [loading, setLoading] = useState(false);

  function formatDate(dateString) {
    const date = new Date(dateString); // Parse the date string
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Get month (0-indexed, so add 1)
    const day = String(date.getDate()).padStart(2, "0"); // Get day
    const year = date.getFullYear(); // Get year

    return `${month}-${day}-${year}`; // Return formatted date as MM-DD-YYYY
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60">
      <div className="bg-white rounded-2xl shadow-lg w-[700px] max-h-[90vh] overflow-y-auto scrollbar-hidden">
        {loading && <Loader />}
        <h3 className="text-xl font-bold mb-6 text-center bg-blue-950 py-3 text-white ">
          Invoice Details
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-6">
          <div className="flex flex-col">
            <label
              htmlFor="number"
              className="text-sm font-medium text-gray-700"
            >
              Invoice Id
            </label>
            <input
              type="number"
              name="number"
              placeholder="Invoice Number"
              value={invoiceDetails?.projectInvoice?.id}
              className="mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500"
              readOnly
            />
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="number"
              className="text-sm font-medium text-gray-700"
            >
              Sub Contractor Name
            </label>
            <input
              type="text"
              name="name"
              placeholder="Subcontractor Name"
              value={invoiceDetails?.projectInvoice?.subContractorName}
              className="mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500"
              readOnly
            />
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="description"
              className="text-sm font-medium text-gray-700"
            >
              Description
            </label>
            <input
              type="text"
              name="description"
              value={invoiceDetails?.projectInvoice?.description}
              className="mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500"
              readOnly
            />
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="invoice-date"
              className="text-sm font-medium text-gray-700"
            >
              Invoice Date
            </label>
            <input
              type="text" // Change to text for formatted date
              name="invoice-date"
              value={formatDate(invoiceDetails?.projectInvoice?.createdAt)}
              className="mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500"
              readOnly
            />
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="start-date"
              className="text-sm font-medium text-gray-700"
            >
              Start Date
            </label>
            <input
              type="text" // Change to text for formatted date
              name="start-date"
              value={formatDate(invoiceDetails?.projectInvoice?.startDate)}
              className="mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500"
              readOnly
            />
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="end-date"
              className="text-sm font-medium text-gray-700"
            >
              End Date
            </label>
            <input
              type="text" // Change to text for formatted date
              name="end-date"
              value={formatDate(invoiceDetails?.projectInvoice?.endDate)}
              className="mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500"
              readOnly
            />
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="invoice-amount"
              className="text-sm font-medium text-gray-700"
            >
              Invoice Amount
            </label>
            <input
              type="number"
              name="invoice-amount"
              value={invoiceDetails?.projectInvoice?.workingHours}
              className="mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500"
              readOnly
            />
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="hst rate"
              className="text-sm font-medium text-gray-700"
            >
              HST ( {invoiceDetails?.hstRate} %)
            </label>
            <input
              type="text"
              name="hst rate"
              value={
                invoiceDetails?.hstAmount
                  ? Number(invoiceDetails.hstAmount).toFixed(2)
                  : ""
              }
              className="mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500"
              readOnly
            />
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="total amount"
              className="text-sm font-medium text-gray-700"
            >
              Total Payble Amount
            </label>
            <input
              type="text"
              name="total amount"
              value={
                (
                      Number(invoiceDetails.projectInvoice.workingHours) +
                      Number(invoiceDetails.hstAmount)
                    ).toFixed(2)
                  
              }
              className="mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500"
              readOnly
            />
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="total amount"
              className="text-sm font-medium text-gray-700"
            >
              Invoice Approval
            </label>
            <input
              type="text"
              name="paid status"
              value={
                invoiceDetails?.projectInvoice?.paidStatus
                  ? "Accepted"
                  : "Not Accepted"
              }
              className={`mt-1 block w-full p-3 border border-gray-800 rounded-md focus:ring focus:ring-blue-500 
                                ${
                                  invoiceDetails?.projectInvoice?.paidStatus
                                    ? "bg-green-100 text-green-800"
                                    : "bg-red-100 text-red-800"
                                }`}
              readOnly
            />
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="document"
              className="text-sm font-medium text-gray-700"
            >
              Document
            </label>

            {invoiceDetails?.projectInvoice?.uploadImage?.endsWith(".pdf") ? (
              <a
                href={invoiceDetails?.projectInvoice?.uploadImage}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center rounded-md p-2 hover:bg-gray-100 transition"
              >
                <img src={pdf} alt="PDF Document" className="mr-2 h-24" />
                <span className="text-blue-600 hover:underline">View PDF</span>
              </a>
            ) : (
              <a
                href={invoiceDetails?.projectInvoice?.uploadImage}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center rounded-md p-2 hover:bg-gray-100 transition"
              >
                <img
                  src={invoiceDetails?.projectInvoice?.uploadImage || noInvoice}
                  alt="Uploaded Document"
                  className="mt-2 rounded-md h-32"
                />
                {/* <span className="ml-20 mt-20 text-blue-600 hover:underline">View Document</span> */}
              </a>
            )}
          </div>

          <div className="flex flex-col">
            <h2 className="font-semibold mt-4">Task Done</h2>
            <div className="mt-2">
              {invoiceDetails?.projectTasks?.map((task, index) => (
                <div key={index} className="text-gray-700 ">
                  {index + 1}. {task?.taskName} - ${task?.taskBudget}
                </div>
              ))}
            </div>
            {/* {console.log("Invoicdeeee", invoiceDetails)}_ */}
            <h2 className="font-semibold mt-4">Equipment Submitted:</h2>
            <div className="mt-2">
              {invoiceDetails?.projectInvoice?.equipmentSubmission
                ?.split(",")
                .map((equip, index) => (
                  <div key={index} className="text-gray-700">
                    {index + 1}. {equip}
                  </div>
                ))}
            </div>
          </div>
        </div>

        <div className="flex justify-end mb-5 mr-10">
          <button
            type="button"
            onClick={close}
            className="border border-gray-800 bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewInvoiceDetails;
